import { ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import theme from './theme';
import LandingPage from './components/LandingPage';
import axios from 'axios';

// Get the API URL from environment variables
const API_URL = process.env.REACT_APP_API_URL;

function App() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [policies, setPolicies] = useState([]);
  const [zeroToleranceTerms, setZeroToleranceTerms] = useState([]);

  const handleProtectSubmit = async (formData) => {
    try {
      setLoading(true);
      setError(null);

      const payload = {
        policies: policies.map(policy => ({
          name: policy.name,
          description: policy.description,
          prohibited_examples: policy.examples
        })),
        zero_tolerance_terms: zeroToleranceTerms,
        text: formData.textToCheck
      };

      console.log('Sending payload:', payload);

      const response = await axios.post(`${API_URL}/check_content`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      setResult(response.data);
    } catch (err) {
      setError(err.message || 'An error occurred while checking the content');
      console.error('API Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePolicyUpdate = (updatedPolicies) => {
    setPolicies(updatedPolicies);
  };

  const handleZeroToleranceUpdate = (updatedTerms) => {
    setZeroToleranceTerms(updatedTerms);
  };

  return (
    <ThemeProvider theme={theme}>
      <LandingPage 
        onProtectSubmit={handleProtectSubmit}
        onPolicyUpdate={handlePolicyUpdate}
        onZeroToleranceUpdate={handleZeroToleranceUpdate}
        result={result}
        loading={loading}
        error={error}
      />
    </ThemeProvider>
  );
}

export default App; 